import { create }									from 'zustand';
import { DateRange }								from 'react-day-picker';
import { ColumnState }								from 'ag-grid-community';
import { defaultMST2010_R01Dto, MST2010_R01Dto }		from './Dto_MST2010_R01';

export interface MST2010_R01Filter {
	areaCd:     string;
	customCd:   string;
	customNm:   string;
	customType: string;
}

export interface Store_MST2010_R01 {
	MST2010_R01Filter: MST2010_R01Filter;
	MST2010_R01PastFilter: MST2010_R01Filter;
	setMST2010_R01Filter: (filter: Partial<MST2010_R01Filter>) => void;
	setMST2010_R01PastFilter: (filter: Partial<MST2010_R01Filter>) => void;

	MST2010_R01List: MST2010_R01Dto[];
	setMST2010_R01List: (MST2010_R01List: MST2010_R01Dto[]) => void;
	removeMST2010_R01: (customCd: string) => void;
	
	selectedMST2010_R01: MST2010_R01Dto | undefined;
	setSelectedMST2010_R01: (MST2010_R01: MST2010_R01Dto | undefined) => void;
	initSelectedMST2010_R01: () => void;
	
	editMST2010_R01: MST2010_R01Dto;
	setEditMST2010_R01: (MST2010_R01: MST2010_R01Dto) => void;
	initEditMST2010_R01: () => void;

	columnState: ColumnState[] | null;			setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;							setAllCount: (allCount: number) => void;

	initData: () => void;

}

export const defaultMST2010_R01Filter: MST2010_R01Filter = {
	areaCd:     '',
	customCd:   '',
	customNm:   '',
	customType: '',
}

export const useMST2010_R01Store = create<Store_MST2010_R01>((set) => ({
	MST2010_R01Filter: defaultMST2010_R01Filter,
	MST2010_R01PastFilter: defaultMST2010_R01Filter,
	setMST2010_R01Filter: (filter: Partial<MST2010_R01Filter>) => set((state) => {
		return {
			MST2010_R01Filter: {
				...state.MST2010_R01Filter,
				...filter
			}
		}
	}),
	setMST2010_R01PastFilter: (filter: Partial<MST2010_R01Filter>) => set((state) => {
		return {
			MST2010_R01PastFilter: {
				...state.MST2010_R01PastFilter,
				...filter
			}
		}
	}),

	MST2010_R01List: [],
	setMST2010_R01List: (MST2010_R01List: MST2010_R01Dto[]) => set((state) => {
		return {
			...state,
			MST2010_R01List: MST2010_R01List
		}
	}),
	removeMST2010_R01: (customCd: string) => set((state) => {
		return {
			...state,
			MST2010_R01List: [...state.MST2010_R01List].filter(value => value.customCd !== customCd)
		}
	}),

	selectedMST2010_R01: undefined,
	setSelectedMST2010_R01: (MST2010_R01: MST2010_R01Dto | undefined) => set((state) => {
		return {
			...state,
			selectedMST2010_R01: MST2010_R01
		}
	}),
	initSelectedMST2010_R01: () => set({ selectedMST2010_R01: undefined, editMST2010_R01: defaultMST2010_R01Dto }),
	
	editMST2010_R01: defaultMST2010_R01Dto,
	setEditMST2010_R01:	(MST2010_R01: MST2010_R01Dto) => set((state) => {
		return {
			...state,
			editMST2010_R01: MST2010_R01
		}
	}),
	initEditMST2010_R01: () => set((state) => {
		return {
			...state,
			editMST2010_R01: defaultMST2010_R01Dto
		}
	}),

	columnState: null,			
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	
	allCount: 0,				
	setAllCount: (allCount: number) => set({ allCount }),

	initData:				() => set((state) => ({
		...state,
		MST2010_R01Filter: defaultMST2010_R01Filter,
		MST2010_R01PastFilter: defaultMST2010_R01Filter,
		columnState: null,
		selectedMST2010_R01: undefined,
		editMST2010_R01: defaultMST2010_R01Dto,
		MST2010_R01List: [],
		allCount: 0,
		scrollTop: null,
	}))
}));
